import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import {
  FormStat,
  FormStatByDate,
  IAnalyticsApi,
  AlarmStatus,
  AlarmHistory,
} from '../api/AnalyticsApi'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'

type Props = {
  apiKey: symbol
}

export interface IAnalyticsService extends IInit {
  getMedicationStats(userId: string): Observable<FormStat[]>
  getFoodStats(userId: string): Observable<FormStat[]>
  getSleepStats(userId: string): Observable<FormStat[]>
  getDayRatingStats(userId: string): Observable<FormStat[]>
  getAlarmStatus(userId: string): Observable<AlarmStatus>
  getAlarmHistory(userId: string): Observable<AlarmHistory[]>
  getMedicationStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]>
  getFoodStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]>
  getSleepStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]>
  getDayRatingStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]>
}

export class AnalyticsService implements IAnalyticsService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IAnalyticsApi
  private _statusService!: IStatusService

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IAnalyticsApi>(this._apiKey)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
  }

  getMedicationStats(userId: string): Observable<FormStat[]> {
    return this._api.getMedicationStats(userId)
  }

  getFoodStats(userId: string): Observable<FormStat[]> {
    return this._api.getFoodStats(userId)
  }

  getSleepStats(userId: string): Observable<FormStat[]> {
    return this._api.getSleepStats(userId)
  }

  getDayRatingStats(userId: string): Observable<FormStat[]> {
    return this._api.getDayRatingStats(userId)
  }

  getAlarmStatus(userId: string): Observable<AlarmStatus> {
    return this._api.getAlarmStatus(userId)
  }

  getAlarmHistory(userId: string): Observable<AlarmHistory[]> {
    return this._api.getAlarmHistory(userId)
  }

  getMedicationStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]> {
    return this._api.getMedicationStatsByRange(userId, startDate, endDate)
  }

  getFoodStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]> {
    return this._api.getFoodStatsByRange(userId, startDate, endDate)
  }

  getSleepStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]> {
    return this._api.getSleepStatsByRange(userId, startDate, endDate)
  }

  getDayRatingStatsByRange(
    userId: string,
    startDate: string,
    endDate: string
  ): Observable<FormStatByDate[]> {
    return this._api.getDayRatingStatsByRange(userId, startDate, endDate)
  }
}
